export default {
      id: "check-on-color2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#check-on-color2",
      toString: function () {
        return this.url;
      }
    }